export default "__VITE_ASSET__W2I3kj9G__"